import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["filterBtn", "filterTab"]
  
  initialize() {
    this.activeCategories = []
  }

  filter(event) {
    event.preventDefault()
    const access = event.currentTarget.dataset.category

    this.filterBtnTargets.forEach(btn => {
      btn.classList.toggle("active", btn.dataset.category === access)
    })

    this.filterTabTargets.forEach(tab => {
      const type = tab.dataset.type || tab.dataset.category
      const shouldShow = (type === access)
      tab.classList.remove("active")
      tab.classList.toggle("d-none", !shouldShow)
      tab.classList.toggle("fade", !shouldShow)
    })

    this.activateFirstVisibleTab()
  } // filter

  multi_filter(event) {
    event.preventDefault()
    const category = event.currentTarget.dataset.category

    if (this.activeCategories.includes(category)) {
      this.activeCategories = this.activeCategories.filter(c => c !== category)
    } else {
      this.activeCategories.push(category)
    }

    this.filterBtnTargets.forEach(btn => {
      const isSelected = this.activeCategories.includes(btn.dataset.category)
      btn.classList.toggle("active", isSelected)
    })

    this.filterTabTargets.forEach(tab => {
      const type = tab.dataset.type
      const shouldShow = this.activeCategories.length === 0 || this.activeCategories.includes(type)
      
      tab.classList.toggle("fade", !shouldShow)
      tab.classList.toggle("d-none", !shouldShow)
    })

    this.activateFirstVisibleTab()
  } // filter

  activateFirstVisibleTab() {
    const firstVisible = this.filterTabTargets.find(tab => !tab.classList.contains("fade"))
    
    if (firstVisible) {
      this.hideAllPanes("show")
      firstVisible.querySelector("a").click()
    }else {
      this.hideAllPanes("hidden")
    }
  } // activateFirstVisibleTab

  hideAllPanes(isShow) {
    if(isShow == "show"){
      document.querySelector("#brandTab").classList.remove("fade")
    }else{
      document.querySelector("#brandTab").classList.add("fade")
    }
  } // hideAllPanes
}